module.exports = __webpack_public_path__ + "img/image_contiract.e00f0d14.png";